import React, { useState, useEffect } from "react";
import PathLink from "../../shared/seo/PathLink";
import { useQuestionContext } from "../../shared/context/QuestionContext";
import QuestionCard from "./QuestionCard";
import ComponentsLoader from "../../components/includes/ComponentsLoader";
import { useTranslation } from "react-i18next";
import { urls } from "../../shared/seo/links";

export default function QuestionsSection() {
  const { t } = useTranslation();
  const Lng = localStorage.getItem("lang");
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getQuestionsByFilter } = useQuestionContext();
  useEffect(() => {
    async function fetchQuestions() {
      const response = await getQuestionsByFilter({
        limit: 4,
        // Only published questions: pending ones are still awaiting review.
        filter: {
          language: Lng,
          status: "published",
        },
      });
      setQuestions(response.data?.questions ?? []);
      setIsLoading(false);
    }
    fetchQuestions();
  }, []);

  return (
    <section className="section section-blogs">
      <div className="container-fluid">
        <div className="section-header text-center aos aos-init aos-animate">
          <h2>{t("Legal_advice")}</h2>
          <p className="sub-title">{t("Legal_advice_description")}</p>
        </div>

        <div
          style={{ marginTop: "20px" }}
          className="row blog-grid-row aos aos-init aos-animate"
        >
          {isLoading ? (
            <ComponentsLoader />
          ) : questions?.length > 0 ? (
            questions.map((questions) => {
              return <QuestionCard questions={questions} />;
            })
          ) : null}
        </div>
        <div className="view-all text-center aos aos-init aos-animate">
          {/* A real link (crawlable), styled as the design-system outline button:
              the template's .btn-primary is fought over by !important rules. */}
          <PathLink to={urls.sectionPath("questions", Lng)} className="avc-btn avc-btn--outline">
            {t("View_All_question")}
          </PathLink>
        </div>
      </div>
    </section>
  );
}
